import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import OnboardingFriendEntry from './OnboardingFriendEntry';
import styles from './OnboardingFbFriendsList.scss';
import { useOnboardingContext } from '../../../../../state/OnboardingContext';
import { t } from '../../../../../shared/onboarding-utils';

const OnboardingFbFriendsList = ({ friends }) => {
  const followableFriends = friends.filter((friend) => friend.isFollowable);
  const friendCount = followableFriends.length;
  const { track } = useOnboardingContext();
  const friendCountMessage = (() => {
    switch (friendCount) {
      case 0:
        return t('facebook.friend_list.no_friends');
      case 1:
        return t('facebook.friend_list.one_friend_to_follow');
      default:
        return t('facebook.friend_list.more_friends_to_follow', {
          friend_count: friendCount
        });
    }
  })();

  useEffect(() => {
    track({
      element: 'facebook_friends_list',
      action: 'screen_enter',
      properties: {
        friends_count: friendCount
      }
    });
  }, [friendCount, track]);

  return (
    <>
      <p>{friendCountMessage}</p>
      {friendCount > 0 && (
        <ul className={styles.friendList}>
          {followableFriends.map((friend) => (
            <OnboardingFriendEntry friend={friend} key={friend.id} />
          ))}
        </ul>
      )}
    </>
  );
};

OnboardingFbFriendsList.propTypes = {
  friends: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default OnboardingFbFriendsList;
